(function (window, document, undefined) {
  "use strict";

  let axios = window.axios,
    Vue = window.Vue || false,
    reactions;

  /**
   * Initialize.
   * Check if Vue is available, get the config.
   *
   * @return {undefined}
   */
  const _init = function () {
    if (!Vue) {
      console.log("_init: No Vue, no parts, no deal.");
      return;
    }

    let config = helpers.parseConfig();
    if (!config) {
      console.log("_init: No config, no parts, no deal.");
      return;
    }

    reactions = Vue.createApp({
      components: {
        Reactions: window["@russmedia-frontend/np-widgets"].Reactions,
      },
      data() {
        return {
          title: config.title,
          stats: [],
          userReactionEvent: {},
          selectedStat: {},
          buttonClass: "vodl-button",
          test: "vodl-reactions__control",
        };
      },
      mounted() {
        // User is logged in OR has a tcf consent, get the stats immediately.
        if (this.getUserIdFromStorage() || this.getTcfStatusFromStorage()) {
          this.getStats();
          return;
        }

        // Otherwise we need to wait for the event to fire.
        document.addEventListener("vodl_tcf_state_initialized", this.getStats);
      },
      methods: {
        /**
         * Create and return a random hash.
         *
         * @return {string}
         */
        createRandomHash() {
          return (
            Math.random().toString(36).substring(2, 15) +
            Math.random().toString(36).substring(2, 15)
          );
        },

        /**
         * Filters and transforms an array of reaction objects.
         *
         * This function takes an array of reaction objects and filters them, ensuring that
         * the 'name' property exists and assigning a default value of an empty string if it's missing.
         * It also includes the 'reactionEventCount' property, assigning a default value of 0 if it's missing.
         *
         * @param {Array} stats - An array of reaction objects to filter and transform.
         * @returns {Array} An array of reaction and transformed statistics objects.
         *
         */
        filterStatsData(stats) {
          const ignoredReactions = ["balanced", "moving", "exciting", "proper"];

          const filteredStats = stats
            .filter((stat) => !ignoredReactions.includes(stat.slug))
            .map((stat) => ({
              name: stat.name || "",
              slug: stat.slug || "like",
              reactionEventCount: stat.reaction_events_count || 0,
            }));

          const orderedStats = filteredStats.sort((a, b) => {
            const order = [
              "star",
              "like",
              "funny",
              "sad",
              "sceptical",
              "surprised",
            ];
            return order.indexOf(a.slug) - order.indexOf(b.slug);
          });

          return orderedStats;
        },

        /**
         * Find the reaction in this.stats that the user may have selected
         * by comparing with this.userReactionEvent.
         */
        markSelected() {
          this.stats.forEach((s) => {
            if (this.userReactionEvent?.reaction?.slug === s.slug) {
              this.selectedStat = s;
            }
          });
        },

        /**
         * Call the reactions API for the stats of our current post object.
         * The stats results will be saved to this.stats.
         * If the current user already reacted,
         * this will be saved to this.userReactionEvent.
         */
        getStats() {
          // url looks like https://www.vol.at/api/reactions/reaction-events/nnp/post/3979618/5zxb05dwgut6fb9ftfss3a
          let url =
            config.api_base +
            config.application +
            "/" +
            config.object_type +
            "/" +
            config.object_id +
            "/" +
            this.getUserId();

          axios({
            method: "get",
            timeout: 1500,
            url: url,
          })
            .then((response) => {
              this.stats = this.filterStatsData(response.data.stats);
              this.userReactionEvent = response.data.user_reaction_event;
              this.markSelected();
            })
            .catch((err) => {
              console.log(err);
            });
        },

        /**
         * Get or create an anonymous user id.
         *
         * @return {string}
         */
        getOrCreateAnonUserId() {
          let userId = this.getUserIdFromCookie();
          if (userId) {
            return userId;
          }

          userId = this.createRandomHash();

          this.setUserIdToCookie(userId);

          return userId;
        },

        /**
         * Read users tcf status from local storage, if available.
         *
         * @return {object|boolean}
         */
        getTcfStatusFromStorage() {
          let storage = window.RussMedia.Utils.LocalStorage || false;
          if (!storage) {
            return false;
          }
          let tcfStatus = storage.get("tcf-status") || false;

          return tcfStatus;
        },

        /**
         * Get the user id, either from local storage (logged in users)
         * or by getting an anonymous user id.
         *
         * @return {string}
         */
        getUserId() {
          let userId = this.getUserIdFromStorage();

          if (!userId) {
            userId = this.getOrCreateAnonUserId();
          }
          return userId;
        },

        /**
         * Read anonymous user id from cookie, if available.
         *
         * @return {string|boolean}
         */
        getUserIdFromCookie() {
          let cookieName = config.cookie_name || false;

          if (!cookieName) {
            return false;
          }

          let result;
          return (result = new RegExp(
            "(?:^|; )" + encodeURIComponent(cookieName) + "=([^;]*)"
          ).exec(document.cookie))
            ? result[1]
            : null;
        },

        /**
         * Read users SSO id from local storage, if available.
         *
         * @return {string|boolean}
         */
        getUserIdFromStorage() {
          let storage = window.RussMedia.Utils.LocalStorage || false;
          if (!storage) {
            return false;
          }
          let userStatus = storage.get("user-status") || false;
          if (!userStatus || !userStatus.ssoId) {
            return false;
          }
          return userStatus.ssoId;
        },

        /**
         * Save (anonymous) user id to cookie.
         *
         * @param {string} value The user id to save.
         */
        setUserIdToCookie(value) {
          const time = new Date();
          time.setFullYear(time.getFullYear() + 1);

          let domain = window.location.hostname;
          let domainArray = domain.split(".");
          if ("www" === domainArray[0] || "nnp" === domainArray[0]) {
            domain = domain.replace(domainArray[0], "");
          }

          document.cookie =
            config.cookie_name +
            "=" +
            value +
            "; path=/; domain=" +
            domain +
            "; expires=" +
            time.toUTCString() +
            ";";
        },

        /**
         * Track a reaction by the given slug.
         *
         * @param  {string} slug
         */
        trackReactionEvent(slug) {
          // Google analytics
          if (window.dataLayer) {
            let payload = {
              event: "genericEvent",
              eventCategory: "ArticleRating",
              eventAction: slug,
              eventLabel: window.location.href,
            };

            window.dataLayer.push(payload);

            document.dispatchEvent(
              new CustomEvent("hansrmdtevent", { detail: payload })
            );
          }
          // OEWA
          let oewa_data = window.oewa_data || false;
          if (oewa_data) {
            if (typeof window.IOMm !== "undefined") {
              window.IOMm("pageview", { cp: oewa_data["cp"] });
            }
          }
        },

        /**
         * Trigger a given reaction.
         *
         * @param  {object} reaction
         */
        triggerReaction(reaction) {
          if (!reaction || !reaction.slug) {
            return;
          }

          // If the reaction is already selected, no need tor trigger again.
          if (reaction.name === this.selectedStat.name) {
            return;
          }

          let url =
            config.api_base +
            config.application +
            "/" +
            config.object_type +
            "/" +
            reaction.slug;
          let payload = {
            user_id: this.getUserId(),
            object_id: config.object_id,
          };

          axios({
            data: payload,
            method: "post",
            timeout: 2000,
            url: url,
          })
            .then((response) => {
              this.stats = this.filterStatsData(response.data.stats);
              this.userReactionEvent = response.data.user_reaction_event;
              this.markSelected();
              this.trackReactionEvent(reaction.slug);
            })
            .catch((err) => {
              console.log(err);
            });
        },
      },
    }).mount(".vodl-reactions-wrapper");
  };

  const helpers = {
    parseConfig: function () {
      const configNode = document.querySelector(
        '.vodl-reactions script[type="application/json"]'
      );

      let parsedConfig = {};

      try {
        parsedConfig = JSON.parse(configNode.innerHTML) || {};
      } catch (e) {
        return false;
      }

      return parsedConfig;
    },
  };

  _init();
})(window, document);
